import React from 'react';
import SEOHead from '../components/SEOHead';

const CookiePolicy = () => {
  return (
    <>
      <SEOHead 
        title="Cookie Policy - Saner Consulting"
        description="Cookie Policy for Saner Consulting. Learn about the cookies we use, why we use them, and how you can manage your cookie preferences."
        keywords="cookies, cookie policy, website cookies, privacy, data protection"
      />

      <div className="page-container">
        {/* Hero Section */}
        <section className="section section-dark">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h1 className="hero-title">Cookie Policy</h1>
                <p className="hero-subtitle">
                  Understanding how we use cookies to improve your browsing experience on our website.
                </p>
                <p className="text-muted">
                  <strong>Last updated:</strong> {new Date().toLocaleDateString('en-GB')}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Cookie Policy Content */}
        <section className="section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="legal-content legal-content-single-column">

                  <h2>1. What Are Cookies?</h2>
                  <p>Cookies are small files stored on your device when you visit our website. We keep this simple - we only use essential cookies needed for the website to work properly.</p>

                  <h2>2. What Cookies We Use</h2>
                  <p><strong>We only use essential cookies.</strong> These are necessary for basic website functions and cannot be disabled:</p>
                  
                  <ul>
                    <li><strong>Cookie Preferences:</strong> Remembers your choice about this cookie notice (stored in your browser's local storage)</li>
                    <li><strong>Form Functionality:</strong> Helps our contact form work properly</li>
                  </ul>

                  <p><strong>We do NOT use:</strong></p>
                  <ul>
                    <li>Tracking or analytics cookies</li>
                    <li>Advertising cookies</li>
                    <li>Social media cookies</li>
                    <li>Any cookies that track your behavior</li>
                  </ul>

                  <h2>3. YouTube Videos</h2>
                  <p>Our website displays YouTube videos. When you play a video, YouTube may set their own cookies. We don't control these cookies - they're managed by YouTube.</p>
                  <p>YouTube's privacy policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></p>

                  <h2>4. Managing Cookies</h2>
                  <p>Since we only use essential cookies, there's nothing to manage! The website needs these basic cookies to function.</p>
                  
                  <p>If you want to disable all cookies in your browser, you can do so in your browser settings, but this may prevent the contact form from working properly.</p>

                  <h2>5. Contact Us</h2>
                  <p>Questions about our cookie use?</p>
                  
                  <div className="contact-info mt-4 p-4 bg-light rounded">
                    <p><strong>Email:</strong> contact@sanerconsulting.co.uk</p>
                    <p><strong>Subject:</strong> Cookie Question</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CookiePolicy;